import { render, staticRenderFns } from "./stats-charts-card.vue?vue&type=template&id=c4d0cbd2&scoped=true&"
import script from "./stats-charts-card.vue?vue&type=script&lang=js&"
export * from "./stats-charts-card.vue?vue&type=script&lang=js&"
import style0 from "./stats-charts-card.vue?vue&type=style&index=0&id=c4d0cbd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d0cbd2",
  null
  
)

export default component.exports